import Joi from 'joi';
import imageWithMetaDataSchema from '@utils/validate/blocksSchemes/imageWithMetadataSchema';
const mediaObjectSchema = Joi.object(imageWithMetaDataSchema).unknown(true);
const mediaUrlSchema = Joi.object({
  desktop: Joi.alternatives().try(Joi.string(), mediaObjectSchema).allow(null, ''),
  tablet: Joi.alternatives().try(Joi.string(), mediaObjectSchema).allow(null, ''),
  mobile: Joi.alternatives().try(Joi.string(), mediaObjectSchema).allow(null, '')
}).unknown(true);
export default mediaUrlSchema;